import React from "react";
import { WaveMesh } from "@/components/effects/WaveMesh";

export const WaveBackground = ({ className = "" }) => {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {/* Ambient glowing blobs */}
      <div className="absolute -left-32 -top-40 h-[42rem] w-[42rem] rounded-full bg-primary/20 blur-[150px] animate-blob" />
      <div
        className="absolute -right-40 top-1/4 h-[38rem] w-[38rem] rounded-full bg-accent/15 blur-[160px] animate-blob"
        style={{ animationDelay: "5s" }}
      />

      {/* Faint grid, fading toward the horizon */}
      <div className="absolute inset-0 bg-grid opacity-30 mask-fade-b" />

      {/* Premium 3D wireframe wave terrain */}
      <WaveMesh className="opacity-90" />

      {/* Soft horizon glow where the terrain meets the scene */}
      <div className="absolute inset-x-0 top-[44%] h-40 bg-gradient-to-b from-primary/10 to-transparent blur-2xl" />

      {/* Bottom vignette to ground the mesh */}
      <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-background/70 to-transparent" />
    </div>
  );
};
